import type { ApiIncomeCalculatorConfig } from '@app/constants/ApiTypes/internalEntities'

import { createSelector } from '@app/utils/createSelector'

import { getIncomeCalculatorConfigsBySlug } from '@app/packages/internalApi/actions/income_calculator_configs'
import { createPromise } from '@app/packages/thunkSelector/promiseState'
import { createLoadable } from '@app/packages/thunkSelector/thunkSelector'

import { callInternalApi } from '@app/store/actions/api'
import { createReduxSlice } from '@app/store/redux_slice'
import { profileRegionSlugResultSelector } from '@app/store/slices/profile_place'

const incomeCalculatorConfigSlice = createReduxSlice<Record<string, ApiIncomeCalculatorConfig>>('income_calculator_configs')

export const currentIncomeCalculatorConfigResultSelector = createSelector(
  [incomeCalculatorConfigSlice.selector, profileRegionSlugResultSelector],
  (configs, regionSlugResult) =>
    createLoadable(c => {
      const slug = c.unwrap(regionSlugResult)
      const config = configs?.[slug]
      if (!config) {
        return c.load(
          createPromise(`Calculator Config for ${slug} must be fetched`, '', async dispatch => {
            const resp = await dispatch(callInternalApi(getIncomeCalculatorConfigsBySlug(slug)))
            dispatch(incomeCalculatorConfigSlice.update(state => ({ ...state, [slug]: resp.data })))
          })
        )
      }
      return config
    })
)
